module.exports = __webpack_public_path__ + "images/cb7021a974a97efaf667f141b1393582-logo3.png";